import React from "react";
import { Translate } from "react-redux-i18n";
import { Button, Icon } from "@blueprintjs/core";
import Image from "../Image";
import ReduxLinkDecorator from "../../containers/ReduxLinkDecorator";
import SendMessageDecorator from "../../containers/SendMessageDecorator";

const CircleCreator = ({ user }) => {
  return (
    <div className="circle-creator">
      <div className="creator-row-aligner">
        <ReduxLinkDecorator goTo={`public-profile/${user.guid}`}>
          <div className="creator-avatar">
            <Image src={user.image_url} alt={user.f_name} />
          </div>
          <div className="creator-meta">
            <div className="creator-label">
              <Translate value="circle.circle_creator" />
            </div>
            <div className="creator-name">
              {user.f_name} {user.l_name}
            </div>
          </div>
        </ReduxLinkDecorator>
        <SendMessageDecorator user_guid={user.guid} >
          <Button
            intent="primary"
            className="cta secondary-color"
            fill={false}>
            <Icon icon="chat" iconSize="24" className="icon" />
          </Button>
        </SendMessageDecorator>
      </div>
    </div>
  );
};

export default CircleCreator;
